import React from 'react';
import { Testimonial } from './types';
import { ScrollingColumn } from './ScrollingColumn';
interface TestimonialsProps {
  title?: string;
  subtitle?: string;
  description?: string;
  testimonials?: Testimonial[];
  'data-id'?: string;
}
const defaultTestimonials: Testimonial[] = [{
  id: '1',
  name: 'Marcus Thompson',
  role: 'Real Estate Investor',
  company: 'Thompson Properties',
  avatar: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
  content: 'AcquireFlow helped me close 12 deals in my first 90 days. The AI targeting is incredible — every offer goes to a motivated seller.',
  verified: true
}, {
  id: '2',
  name: 'Sarah Chen',
  role: 'Wholesaler',
  company: 'Metro Deals LLC',
  avatar: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?ixlib=rb-1.2.1&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
  content: 'I was spending 20+ hours a week on direct mail. Now it takes me 30 minutes to send 500 personalized offers. Game changer.',
  verified: true
}, {
  id: '3',
  name: 'David Rodriguez',
  role: 'Fix & Flip Investor',
  company: 'Rodriguez Investments',
  avatar: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?ixlib=rb-1.2.1&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
  content: 'The response rate is 3x higher than my old campaigns. The AI knows exactly what to say to get sellers to respond.',
  verified: true
}, {
  id: '4',
  name: 'Jennifer Martinez',
  role: 'Investment Firm Owner',
  company: 'Apex Real Estate Group',
  avatar: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixlib=rb-1.2.1&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
  content: 'We scaled from 2 markets to 8 markets without hiring additional staff. AcquireFlow handles everything automatically.',
  verified: true
}, {
  id: '5',
  name: 'Robert Kim',
  role: 'Real Estate Investor',
  company: 'Kim Capital',
  avatar: 'https://images.unsplash.com/photo-1519345182560-3f2917c472ef?ixlib=rb-1.2.1&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
  content: 'Best investment I made this year. One deal paid for the entire annual subscription 10x over.',
  verified: true
}, {
  id: '6',
  name: 'Amanda Foster',
  role: 'Buy & Hold Investor',
  company: 'Foster Rentals',
  avatar: 'https://images.unsplash.com/photo-1487412720507-e7ab37603c6f?ixlib=rb-1.2.1&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
  content: 'The deal pipeline feature keeps me organized. I never lose track of a hot lead anymore.',
  verified: true
}, {
  id: '7',
  name: 'James Wilson',
  role: 'Real Estate Investor',
  company: 'Wilson Investments',
  avatar: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-1.2.1&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
  content: 'The automated follow-up system is brilliant. I never miss a callback and my conversion rate doubled.',
  verified: true
}, {
  id: '8',
  name: 'Lisa Anderson',
  role: 'Property Flipper',
  company: 'Anderson Flips',
  avatar: 'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?ixlib=rb-1.2.1&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
  content: 'Found 3 off-market deals in my first month. The AI targeting is scary accurate.',
  verified: true
}, {
  id: '9',
  name: 'Michael Brown',
  role: 'Rental Portfolio Owner',
  company: 'Brown Properties',
  avatar: 'https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?ixlib=rb-1.2.1&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
  content: 'Expanded my rental portfolio by 8 properties this year thanks to AcquireFlow. Worth every penny.',
  verified: true
}, {
  id: '10',
  name: 'Emily Turner',
  role: 'Real Estate Wholesaler',
  company: 'Turner Deals',
  avatar: 'https://images.unsplash.com/photo-1580489944761-15a19d654956?ixlib=rb-1.2.1&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
  content: 'The response tracking keeps me on top of every lead. My closing rate went from 2% to 7%.',
  verified: true
}, {
  id: '11',
  name: 'Daniel Lee',
  role: 'Investment Analyst',
  company: 'Lee Capital Group',
  avatar: 'https://images.unsplash.com/photo-1492562080023-ab3db95bfbce?ixlib=rb-1.2.1&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
  content: 'The analytics dashboard gives me insights I never had before. Data-driven decisions for every deal.',
  verified: true
}, {
  id: '12',
  name: 'Rachel Green',
  role: 'Real Estate Investor',
  company: 'Green Investments',
  avatar: 'https://images.unsplash.com/photo-1534528741775-53994a69daeb?ixlib=rb-1.2.1&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
  content: 'Finally, a tool that actually saves time instead of creating more work. Highly recommend.',
  verified: true
}];
export function Testimonials({
  title = 'Success Stories',
  subtitle = 'What Our Clients Say',
  description = "Join 200+ investors who are closing more deals with AcquireFlow. Here's what they have to say about their experience.",
  testimonials = defaultTestimonials,
  'data-id': dataId
}: TestimonialsProps) {
  // Split testimonials into three columns
  const column1 = testimonials.slice(0, 4);
  const column2 = testimonials.slice(4, 8);
  const column3 = testimonials.slice(8, 12);
  return <div className="relative w-full flex justify-center items-center py-24 md:py-32 px-6 md:px-8 overflow-hidden" data-id="element-1678">
      <div className="relative max-w-[1280px] w-full flex flex-col items-center gap-12 md:gap-16" data-id="element-1679">
        {/* Header Section */}
        <div className="w-full flex flex-col items-center gap-6 text-center px-4 animate-fadeIn" data-id="element-1680">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-[#3ab795]/10 border border-[#3ab795]/20 backdrop-blur-sm" data-id="element-1681">
            <div className="w-2 h-2 rounded-full bg-[#3ab795] animate-pulse" data-id="element-1682" />
            <p className="text-sm md:text-base font-medium text-[#3ab795] tracking-wide uppercase" data-id="element-1683">
              {title}
            </p>
          </div>
          <h2 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold text-[#1D1D1D] tracking-tight leading-tight max-w-4xl" data-id="element-1684">
            {subtitle}
          </h2>
          <p className="text-lg md:text-xl leading-relaxed text-gray-600 max-w-2xl font-light" data-id="element-1685">
            {"Join 30+ investors who are closing more deals with AcquireFlow. Here's what they have to say about their experience."}
          </p>
        </div>
        {/* Testimonials Columns */}
        <div className="flex gap-4 md:gap-6 items-center justify-center w-full overflow-x-auto lg:overflow-x-visible scrollbar-hide" data-id="element-1686">
          <div className="flex gap-4 md:gap-6 lg:flex-nowrap" data-id="element-1687">
            <ScrollingColumn testimonials={column1} direction="up" speed={15} data-id="element-1688" />
            <ScrollingColumn testimonials={column2} direction="down" speed={15} data-id="element-1689" />
            <ScrollingColumn testimonials={column3} direction="up" speed={15} data-id="element-1690" />
          </div>
        </div>
      </div>
    </div>;
}